const AuthForm = ({
	email,
	setEmail,
	password,
	setPassword,
	error,
	translate,
	emailRef,
}) => {
	return (
		<>
			<div className="form-group">
				<label htmlFor="email">{translate("login.email")}</label>
				<input
					ref={emailRef}
					id="email"
					className="field"
					type="email"
					required
					value={email}
					onChange={e => setEmail(e.target.value)}
					placeholder={translate("login.emailPlaceholder")}
				/>
			</div>

			<div className="form-group">
				<label htmlFor="password">{translate("login.password")}</label>
				<input
					id="password"
					className="field"
					type="password"
					required
					value={password}
					onChange={e => setPassword(e.target.value)}
					placeholder={translate("login.passwordPlaceholder")}
				/>
			</div>

			{error && <p className="error-message">{error}</p>}
		</>
	);
};

export default AuthForm;
